import React from "react";
import classNames from "classnames";

import { Props } from "./types";
import styles from "./styles.scss";

function ToggleInput(props: Props) {
  return (
    <div
      className={classNames(styles.toggleInput, {
        [styles.toggled]: props.isToggled,
      })}
      onClick={props.toggle}
    />
  );
}

export { ToggleInput };
